<template>
  <v-breadcrumbs :items="items">
    <template v-slot:divider>
      <v-icon   color= "grey" > mdi-chevron-right</v-icon>
    </template>
    <template v-slot:item="props">
      <a
        :class="[props.item.disabled && 'disabled']"
        @click="sendNewPath(props.item.path)"
      >{{ props.item.text}}</a>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  methods: {
    sendNewPath: function(value) {
        this.$emit("changeloaded", value);
    }
  },
  computed: {
    items: function() {
      let items = [
        {
          text:
            this.translatedPath.charAt(0).toUpperCase() +
            this.translatedPath.slice(1),
          disabled: true,
          path: this.path
        }
      ];
      for (let i = 0; i < this.subpathArray.length; i++) {
        if (this.subpathArray[i] != "") {
          items.push({
            text:
              this.subpathArray[i].name.charAt(0).toUpperCase() +
              this.subpathArray[i].name.slice(1),
            disabled: true,
            path: this.subpathArray[i].subpath
          });
        }
      }

      for (let i = 0; i < items.length - 1; i++) {
        items[i].disabled = false;
      }
      return items;
    }
  },
  props: {
    path: String,
    subpath: Array,
    changeLang: Boolean
  },
  data: () => ({
    translatedPath: "",
    subpathArray: []
  }),
  watch: {
    path: function() {
      this.subpathArray = [];
      switch (this.path) {
        case "dataHome":
          this.translatedPath = this.$t("Breadcrumb.dataHome");
          break;
        case "settings":
          this.translatedPath = this.$t("Breadcrumb.settings");
          break;
        case "networks":
          this.translatedPath = this.$t("Breadcrumb.networks");
          break;
        case "deviceTypes":
          this.translatedPath = this.$t("Breadcrumb.deviceTypes");
          break;
        case "admin":
          this.translatedPath = this.$t("Breadcrumb.admin");
          break;
      }
    },
    subpath: function(value) {
      this.subpathArray = value;
    },
    changeLang: function(value) {
      if (value) {
        this.subpathArray = [];
        switch (this.path) {
          case "dataHome":
            this.translatedPath = this.$t("Breadcrumb.dataHome");
            break;
          case "settings":
            this.translatedPath = this.$t("Breadcrumb.settings");
            break;
          case "networks":
            this.translatedPath = this.$t("Breadcrumb.networks");
            break;
          case "deviceTypes":
            this.translatedPath = this.$t("Breadcrumb.deviceTypes");
            break;
          case "admin":
            this.translatedPath = this.$t("Breadcrumb.admin");
            break;
        }
      }
    }
  }
};
</script>

<style>
.disabled {
  color: grey !important;
  pointer-events: none;
}
</style>